// extracted by mini-css-extract-plugin
module.exports = {"card-leading-icon":"style_card-leading-icon__W3mcN"};